// @flow

import React from 'react'

import { CCLabel, type CCLabelColor } from '../../../../UI'

type Row = {
  status: 'training' | 'trained' | 'error'
}

type Props = {
  row: Row
}

function getText (row: Row): string {
  const values = {
    training: 'Training',
    trained: 'Trained',
    error: 'Error'
  }

  return values[row.status]
}

function getColor (row: Row): CCLabelColor {
  const values = {
    training: 'gray',
    trained: 'success-green',
    error: 'red'
  }

  return values[row.status]
}

export function StatusCell ({ row }: Props) {
  return <CCLabel text={getText(row)} color={getColor(row)} />
}
